import React from 'react';
import { Dialogs, Dialog } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import HistoryViewEditor from "../editors/HistoryViewEditor.js";
import UserSettingsModelEditor from "../../../views/userSettings/UserSettingsModelEditor.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon,
  tfIcon
} = I18N.ns('molten.dataViewers.history.SettingsAction');
export default {
  id: 'history.SettingsAction',
  matches: {
    use: 'actionBar',
    client: ['historyTableSupport']
  },
  handles: () => true,
  layout: {
    group: ['Settings'],
    groupIcons: [tfIcon('settingsIcon', 'fa fa-cog fa-fw')]
  },
  appearance: () => {
    return {
      name: t('name'),
      icon: tIcon('historyIcon', 'fa fa-history fa-fw')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    const {
      settingsPath,
      objectType,
      model,
      View,
      options,
      delegate
    } = clientProps;
    Dialogs.show({
      component: props => {
        const {
          show,
          onClose
        } = props;
        return /*#__PURE__*/_jsx(Dialog, {
          show: show,
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onClose: onClose,
          children: /*#__PURE__*/_jsx(UserSettingsModelEditor, {
            ...props
          })
        });
      },
      props: {
        editor: HistoryViewEditor,
        settingsPath,
        versionsPath: `${objectType}.historyScreen`,
        // 'cow.tableModel',
        title: t('title'),
        modelName: t('modelName'),
        editorProps: {
          delegate,
          objectType,
          View,
          options,
          filter: item => item[0] === objectType
        },
        value: model
      }
    });
  }
};